import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter           from "@/services/utils/figureFormatter";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const { formatDate } = useDate();
    const store = useStore();
    const { commaFormat } = figureFormatter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, moneyReceipt, total, date, payload) => {

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 30, 100, 30, 80 ],
            pageOrientation: 'landscape',
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(moneyReceipt, total, date, payload),


            styles : {
                header: {
                    fontSize: 24
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'DUE REPORT'
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (moneyReceipt, total, date, payload) => {
        return [
            {
                text: 'DUE REPORT',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },

            {
                stack: [
                    {
                        text: `Date: ${date.startDate} - ${date.endDate}`
                    },

                    {
                        text: `${payload.businessName ? 'Business Unit: ' +  payload.businessName : ''}`
                    },

                    {
                        text: `${payload.customerName ? 'Customer: ' + payload.customerName : ''}`
                    },

                    {
                        text: `${payload.billType ? 'Bill Type: ' + payload.billType : ''}`
                    },

                    {
                        text: `${payload.orderType ? 'Order Type: ' + payload.orderType : ''}`
                    },

                    {
                        text: `${payload.paymentStatus ? 'Payment Status: ' + payload.paymentStatus : ''}`
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: getTableBody(moneyReceipt, total)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getTableBody = (moneyReceipt, total) => {
        const header = getTableHead();
        const row = getTableRow(moneyReceipt, total);
        return [
            header,
            ...row
        ]
    }

    const getTableRow = (moneyReceipt, total) => {
        const data = [];

        moneyReceipt.map((child) => {
            const row = [
                { text: child.bill_number },
                { text: child.date },
                { text: child.contact_name },
                { text: child.contact_profile_id },
                { text: commaFormat(child.total_amount), alignment: 'right' },
                { text: commaFormat(child.discount), alignment: 'right' },
                { text: commaFormat(child.total_amount - child.discount), alignment: 'right' },
                { text: commaFormat(child.paid_amount), alignment: 'right' },
                { text: commaFormat(child.adjusted_amount - child.discount), alignment: 'right' },
                { text: commaFormat(getDue(child)), alignment: 'right' }
            ];
            data.push(row);
        })

        const totalRow = [
            { text: `Total`, colSpan: 4, alignment: 'right' },
            {}, {}, {},
            { text: total.total_subtotal_amount, alignment: 'right' },
            { text: total.total_discount_amount, alignment: 'right' },
            { text: commaFormat(getNetAmount(total)), alignment: 'right' },
            { text: total.total_paid_amount, alignment: 'right' },
            { text: total.total_adjusted_amount, alignment: 'right' },
            { text: total.total_due_amount, alignment: 'right' }
        ];

        data.push(totalRow);
        return data
    }
    
    const getTableHead = () => {
        return [
            { text: 'INVOICE NO' },
            { text: 'INVOICE DATE' },
            { text: 'CLIENT NAME' },
            { text: 'CLIENT ID' },
            { text: 'TOTAL AMOUNT', alignment: 'right' },
            { text: 'DISCOUNT AMOUNT', alignment: 'right' },
            { text: 'NET AMOUNT', alignment: 'right' },
            { text: 'PAID AMOUNT', alignment: 'right' },
            { text: 'ADJUSTED AMOUNT', alignment: 'right' },
            { text: 'DUE AMOUNT', alignment: 'right' }
        ]
    }

    const getHeader = (company) => {
        return {
            margin: [ 30, 25, 30, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        company.name,
                        'Address: ' + company.address,
                        'Phone: ' + company.phone,
                        'E-mail: ' + company.email
                    ]
                }
            ]
        }
    }

    const getFooter = (userName) => {
        return {
            margin: [ 25, 0 ],
            columns: [
                {
                    columns: [
                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    const getDue = (item) => {
        return parseFloat(item.total_amount) - 
                parseFloat(item.paid_amount) - 
                parseFloat(item.adjusted_amount);
    }

    const getNetAmount = (total) => {
        const amount = parseFloat(total.total_subtotal_amount.replace(/,/g, ''));
        const discount = parseFloat(total.total_discount_amount.replace(/,/g, ''));
        return amount - discount;
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
